import React, { FC, useEffect, useState } from "react";
import "./indec.css";
import shareIOS from "../../assets/images/share-ios.png";

const InstallAppPromptIOS: FC = () => {
  const [state, setState] = useState({
    show: false,
  });

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const winVav: any = window.navigator;
    const isInStandaloneMode = "standalone" in winVav && winVav.standalone;
    setState((prevState) => ({
      ...prevState,
      show: /iphone|ipad|ipod/.test(userAgent) && !isInStandaloneMode,
    }));
  }, []);

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  const href = window?.location?.href || "";

  if (state.show && !href.includes("/proforma-invoice")) {
    return (
      <div className="banner-ios">
        <div style={{ textAlign: "end" }}>
          <button className="closeBtn-ios" onClick={handleClose}>
            x
          </button>
        </div>
        <div className="banner-title-ios">
          <div className="banner-text-ios">
            جهت نصب سامانه مشترکین زی‌تل، <img src={shareIOS} width={25} alt="share ios" /> را انتخاب کنید و سپس روی
            گزینه Add to homescreen کلیک کنید.
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default InstallAppPromptIOS;
